import { render, staticRenderFns } from "./CoursesHistoryTable.vue?vue&type=template&id=688bf166"
import script from "./CoursesHistoryTable.vue?vue&type=script&lang=js"
export * from "./CoursesHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports